import { render, staticRenderFns } from "./NonGeoPickls.vue?vue&type=template&id=2984c631&scoped=true&"
import script from "./NonGeoPickls.vue?vue&type=script&lang=ts&"
export * from "./NonGeoPickls.vue?vue&type=script&lang=ts&"
import style0 from "./NonGeoPickls.vue?vue&type=style&index=0&id=2984c631&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2984c631",
  null
  
)

export default component.exports